export default __webpack_public_path__ + "static/media/desktop-graph-preview.210d455a.png";